import styled from 'styled-components';

export const PhotosTileStyled = styled.div`
  margin: 16px 0;
  height: 268px;
  width: 100%;
  background-color: transparent;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  &.static-mode {
    .images-view {
      position: absolute;
      top: 0;
      left: 0;
      transform: none;
      width: 100%;
      height: 100%;
      padding: 0;
    }

    .static-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center top;
    }
  }

  .images-view {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 472px;
    height: 100%;

    .images-view-line {
      &:not(:first-child) {
        margin-top: 4px;
      }

      &:nth-child(even) {
        transform: translateX(33px);
      }

      &:nth-child(2) {
        opacity: 0.9;
      }

      &:nth-child(3) {
        opacity: 0.6;
      }

      &:nth-child(4) {
        opacity: 0.3;
      }

      display: flex;
      gap: 4px;

      img {
        display: block;
        width: 64px;
        height: 64px;
        border-radius: 12px;
      }
    }
  }
`;
